import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';

import ServicesApi from '../services/api/service.js';

export default {
    mixins: [pageLoadingStatusMixin],
    computed: {
        ...mapGetters({
            currentCustomer: 'user/currentCustomer'
        }),
        /**
         * Check if the user can make an order.
         *
         * @return {boolean}
         */
        canOrder() {
            return this.currentCustomer && this.currentCustomer.availableActions.includes('createOrders');
        }
    },
    methods: {
        /**
         * Get the services.
         */
        getServices() {
            this.startLoading();

            ServicesApi.get().finally(this.finishLoading);
        }
    }
};
